module.exports = __webpack_public_path__ + "img/11.80e66131.png";